import { useEffect, useMemo } from "react";
import { CompanyNumbersByCompany } from "../../components/virtual-receptionist/porting-request/hooks/useCompanyNumbersMultiQuery";
import { useWatchVrNotification } from "./useWatchVrBaseNotification";
import { socket } from "src/sockets/socket-vr";

export interface IUseWatchSmsVrNotificationProps<TPayload> {
    companieNumbers: CompanyNumbersByCompany[];
    notificationTypes: string[];
    disableSnackbarAlert?: boolean;
    onNotificationArrived?: (notification?: TPayload) => void;
    buildSnackbarMessage?: (notification: TPayload) => string;
}

export function useWatchSmsVrNotification<TPayload>({
    companieNumbers,
    notificationTypes,
    disableSnackbarAlert,
    onNotificationArrived,
    buildSnackbarMessage,
}: IUseWatchSmsVrNotificationProps<TPayload>) {
    const allPhoneNumbers = useMemo(() => {
        return companieNumbers.flatMap((company) =>
            company.phoneNumbers.map((n) => n.phoneNumber),
        );
    }, [companieNumbers]);

    // Join/leave a todos los números
    useEffect(() => {
        if (!socket || allPhoneNumbers.length === 0) return;

        console.log("[SMS SOCKET] Joining rooms:", allPhoneNumbers);

        allPhoneNumbers.forEach((twilioNumber) => {
            socket.emit("join", { twilioNumber });
        });

        return () => {
            allPhoneNumbers.forEach((twilioNumber) => {
                socket.emit("leave", { twilioNumber });
            });
        };
    }, [allPhoneNumbers]);

    // Delega toda la lógica de listeners al base
    return useWatchVrNotification<TPayload>({
        notificationTypes,
        disableSnackbarAlert,
        onNotificationArrived,
        buildSnackbarMessage,
    });
}